<template>
  <div v-bind:style="styleObject">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: ['positionStyle', 'instance'],
  data: function () {
    return {
      styleObject: {
        ...this.positionStyle,
        ...this.formatStyle(),
        zIndex: 999,
      },
    };
  },
  methods: {
    formatStyle() {
      const fixedWidth = this.instance && this.instance.fixedWrapperStyle && this.instance.fixedWrapperStyle.width;
      const fixedHeight = this.instance && this.instance.fixedWrapperStyle && this.instance.fixedWrapperStyle.height;
      const commonWidth = this.instance && this.instance.commonStyle && this.instance.commonStyle.width;
      return {
        width: fixedWidth || (commonWidth ? 'auto' : '100%'),
        height: fixedHeight || 'auto',
      };
    }
  }
}
</script>
